/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {QuestionnaireModel} from "../../models/questionnaire-model";

export interface QuestionnairesGetParams {
    includeDetailsForm?: boolean;
    includeMainSurveysOnly?: boolean;
    includeArchived?: boolean;
}

export function questionnairesGet(http: HttpClient, rootUrl: string, params: QuestionnairesGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireModel[]>> {
    const rb = new RequestBuilder(rootUrl, questionnairesGet.PATH, 'get');
    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    if (params.includeDetailsForm) {
        rb.query('includeDetailsForm', params.includeDetailsForm)
    }
    if (params.includeMainSurveysOnly) {
        rb.query('includeMainSurveysOnly', params.includeMainSurveysOnly)
    }
    if (params.includeArchived !== undefined) {
        rb.query('includeArchived', params.includeArchived)
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<QuestionnaireModel[]>;
        })
    );
}

questionnairesGet.PATH = '/api/v1/questionnaires';
